module.exports = __webpack_public_path__ + "static/media/tourGraphics.0b4ee078.png";